var _a;
import { UiSidebarMutationTypes } from '@/types/ui-sidebar';
var STORAGE_KEY = 'ccw_sidebar_collapsed';
export var state = function () { return ({
    collapsed: false
}); };
export var getters = {
    collapsed: function (state) {
        return state.collapsed;
    }
};
export var mutations = (_a = {},
    _a[UiSidebarMutationTypes.INIT_STATE] = function (state, payload) {
        Object.assign(state, payload);
    },
    _a[UiSidebarMutationTypes.SET_COLLAPSED] = function (state, payload) {
        state.collapsed = payload;
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        commit(UiSidebarMutationTypes.INIT_STATE, state());
    },
    initCollapsed: function (_a) {
        var commit = _a.commit;
        if (typeof window === 'undefined')
            return;
        try {
            var stored = window.localStorage.getItem(STORAGE_KEY);
            if (stored !== null) {
                commit(UiSidebarMutationTypes.SET_COLLAPSED, stored === 'true');
            }
        }
        catch (e) {
            // localStorage 参照不可時は既定(展開)のまま
        }
    },
    // 特定の画面の都合で一時的に畳む用。toggleCollapsed と違い保存値には触らないので、
    // その画面を離れれば restoreCollapsed でユーザーの設定に戻せる
    setCollapsed: function (_a, payload) {
        var commit = _a.commit;
        commit(UiSidebarMutationTypes.SET_COLLAPSED, payload);
    },
    // initCollapsed と違い、未保存でも必ず既定(展開)を書き込む。
    // 一時的に畳んだ状態から確実に戻すため
    restoreCollapsed: function (_a) {
        var commit = _a.commit;
        var next = false;
        if (typeof window !== 'undefined') {
            try {
                var stored = window.localStorage.getItem(STORAGE_KEY);
                if (stored !== null)
                    next = stored === 'true';
            }
            catch (e) {
                // 参照不可時は既定(展開)に戻す
            }
        }
        commit(UiSidebarMutationTypes.SET_COLLAPSED, next);
    },
    toggleCollapsed: function (_a) {
        var commit = _a.commit, getters = _a.getters;
        var next = !getters.collapsed;
        commit(UiSidebarMutationTypes.SET_COLLAPSED, next);
        if (typeof window === 'undefined')
            return;
        try {
            window.localStorage.setItem(STORAGE_KEY, String(next));
        }
        catch (e) {
            // 保存失敗は無視(表示状態は反映済み)
        }
    }
};
